import { useLocalStorageState } from "./useLocalStorageState";

export const useLocalStorageUserSettings = () => {
  const [savedRecentWallet, saveRecentWallet] = useLocalStorageState(
    "recent wallet",
    ""
  );

  const [termsAgreement, setTermsAgreement] =
    useLocalStorageState("termsAgreed");

  const [jurisdictionConsent, setJurisdictionConsent] =
    useLocalStorageState("jurisdictionAgreed");

  const [expertUserConsent, setExpertUserConsent] =
    useLocalStorageState("expertUser");

  return [
    savedRecentWallet,
    saveRecentWallet,
    termsAgreement,
    setTermsAgreement,
    jurisdictionConsent,
    setJurisdictionConsent,
    expertUserConsent,
    setExpertUserConsent,
  ];
};
